<div class="staged-input">
  <label class="staged-input__label">{{ label() | translate }}</label>
  <div class="staged-input__field">
    <button
      class="low-level"
      type="button"
      [ngClass]="{
        'low-level--active': !!stageValue,
      }"
      (click)="setStageValue(stageValueEnums.Low)">
      <span class="low-level__bar"></span>
      <span class="low-level__text">{{ 'global.low' | translate }}</span>
    </button>
    <button
      class="normal-level"
      type="button"
      [ngClass]="{
        'normal-level--active':
          stageValue === stageValueEnums.Normal ||
          stageValue === stageValueEnums.High,
      }"
      (click)="setStageValue(stageValueEnums.Normal)">
      <span class="normal-level__bar"></span>
      <span class="normal-level__text">{{ 'global.normal' | translate }}</span>
    </button>
    <button
      class="high-level"
      type="button"
      [ngClass]="{
        'high-level--active': stageValue === stageValueEnums.High,
      }"
      (click)="setStageValue(stageValueEnums.High)">
      <span class="high-level__bar"></span>
      <span class="high-level__text">{{ 'global.high' | translate }}</span>
    </button>
  </div>
</div>
